import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import PrimeTable from "../../../components/PrimeTable";
import { useCallback, useEffect, useMemo, useState } from "react";
import appActions from '../../../appActions';
import SysEventsFilterForm from "./SysEventsFilterForm";
import { Button } from "primereact/button";

const SysEventsList =()=>{

    let navigate = useNavigate();
    const dispatch = useDispatch();

    const sysEventList = useSelector ((state) => state.sysEvents.sysEventsList);
    const filters = useSelector((state) => state.sysEvents.filters);

    const defaultParams = useMemo(() => ({
        ...filters,
        pageno: 1,
        pagesize: 50,
        sort: 'createdOn',
        sortOrder: -1,
    }), [filters]);

    const [formValues, setFormValues] = useState(defaultParams)

    const handleFormValuesChange = (values) => {
        setFormValues(values);
    }
    
    const handleRefresh = useCallback(() => {
        dispatch(appActions.SYSEVENTS_GET_ALL_REQUEST(defaultParams));
    },[ dispatch, defaultParams ]);

    const renderHeader = () => {
        return (
            <div className="d-flex flex-row gap-10 align-items-center">
                <h1 className="page-header flex"> POS Command Events </h1>
                <Button icon="pi pi-sync" rounded text aria-label="Refresh" className='mr-auto tp' data-pr-tooltip="Refresh" onClick={handleRefresh} />
            </div>
        );
    };

    const handleReset = () => {
        setFormValues(defaultParams)
        dispatch(appActions.STOREITEMS_GET_ALL_REQUEST(defaultParams));
    }

    const handleSearch = useCallback(
        (params) => {
            const searchParams = {
                ...params,
                pagesize: params.pagesize || defaultParams?.pagesize,
                pageno: params.pageno || defaultParams?.pageno,
                sort: params.sort || defaultParams?.sort,
                sortOrder: params.sortOrder || defaultParams?.sortOrder,
            };
            dispatch(appActions.SYSEVENTS_GET_ALL_REQUEST(searchParams));
        },
        [dispatch, defaultParams?.pageno, defaultParams?.pagesize, defaultParams?.sort, defaultParams?.sortOrder]
    );

    useEffect(() => {
        handleSearch(defaultParams);
    }, []); // Empty dependency array ensures it runs only on mount
    
    const handleViewRedirect = useCallback((record) => {
        const data = sysEventList?.data?.find(t => t.id === record.id);
        navigate('/ui/sys-events/details', { state: { data, isView: true } });
    }, [sysEventList, navigate]);

    const actionTemplate = useCallback(
        (rowData) => (
            <div className="flex gap-10 justify-content-center">
                <span className="cursor-pointer tp" onClick={() => handleViewRedirect(rowData)} data-pr-tooltip="View">
                    <i className="pi pi-eye text-blue-500 text-base"></i>
                </span>
            </div>
        ),
        [handleViewRedirect]
    );

    const onFilterChangeCallback  = useCallback(
        (e) => {

            const { sortField, sortOrder, rows, page } = e;
            
            const params = {...formValues, pagesize: rows, pageno: page, sort: sortField, sortOrder: sortOrder };

            setFormValues(prevFormValues => ({
                ...prevFormValues,
                sort: sortField, 
                sortOrder: sortOrder,
                pagesize: rows,
                pageno: page
            }));

            handleSearch(params); // Call search with updated sorting params
        },
        [handleSearch, formValues],
    );
    
    const columns = [       
        { field: 'storeId', header: 'StoreId', sortable: true, fileLog: true, width: '100px' },
        { field: 'cmdType', header: 'CMD Type', sortable: true },
        { field: 'cmdDate', header: 'CMD Date', sortable: true, width: '120px' },
        // { field: 'cmdTime', header: 'CMD Time', sortable: true},
        { field: 'cmdValidity', header: 'CMD Validity', sortable: true, width: '130px' },
        { field: 'processed', header: 'Processed', sortable: true, fileLog: true, width: '100px' },
        { field: 'processedOn', header: 'Pocessed On', sortable: true, fileLog: true, width: '130px' },
        { field: 'status', header: 'Status', sortable: true, width: '120px' },       
        { field: 'createdOn', header: 'Created On', sortable: true, width: '140px', columnType: 'datetime' },   
        // { field: 'lastUpdated', header: 'Last Updated', sortable: true, columnType : 'datetime'  },
        // { field: 'lastUpdatedBy', header: 'Last Updated By', sortable: true },
    ];


    const renderList = () => {
        return (
            <>
                <div className='pv-15 ph-15'>
                    {renderHeader()}
                </div>
                <div className="bg-white mx-3 pv-15 ph-15 br-6 shadow-white">
                    <SysEventsFilterForm 
                        handleSearch={handleSearch} 
                        handleReset={handleReset}  
                        onFormValuesChange={handleFormValuesChange} 
                    />
                    <div className='custom-devider'></div>
                    <PrimeTable
                        list={sysEventList}
                        columns={columns}
                        actionColumn={actionTemplate}
                        onFilterChangeCallback={(e) => {
                            onFilterChangeCallback(e);
                        }}
                        tableName='api_logs'
                        isLazy={true}
                        showGenerateXmlBtn={false}
                    />
                </div>
            </>
        );
    };

    return <div className="form_height">{renderList()}</div>;

}

export default SysEventsList;

